<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M4.92773 8.00391V10.6449"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.24845 9.32422H3.60742"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.79061 5.17383H4.7426C2.99557 5.17383 1.52793 6.48744 1.335 8.22378L0.863923 12.4634C0.6922 14.009 1.90198 15.3607 3.45701 15.3607C4.44524 15.3607 5.34866 14.8023 5.79061 13.9184L6.20136 13.0969H9.59696L10.0077 13.9184C10.4497 14.8023 11.3531 15.3607 12.3413 15.3607C13.8963 15.3607 15.1061 14.009 14.9344 12.4634L14.4633 8.22377"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.87891 9.98463C9.87891 9.82835 10.0056 9.70166 10.1619 9.70166C10.3182 9.70166 10.4448 9.82835 10.4448 9.98463"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.87891 9.98438C9.87891 10.1406 10.0056 10.2673 10.1619 10.2673C10.3182 10.2673 10.4448 10.1406 10.4448 9.98438"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.19923 4.56416C7.79818 4.49439 7.79817 3.91864 8.19923 3.84887C9.65221 3.59609 10.8079 2.4894 11.1232 1.0487L11.1474 0.938268C11.2342 0.541887 11.7985 0.539421 11.8888 0.935028L11.9182 1.06372C12.2452 2.49761 13.4012 3.59497 14.8501 3.84704C15.2532 3.91718 15.2532 4.49585 14.8501 4.56599C13.4012 4.81806 12.2452 5.91542 11.9182 7.3493L11.8888 7.478C11.7985 7.87361 11.2342 7.87114 11.1474 7.47477L11.1232 7.36433C10.8079 5.92365 9.65221 4.81694 8.19923 4.56416Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
